import BaseWebSocketSubscriber from './base.websocket.subscriber'

const MESSAGE_TYPES = {
  CERTIFICATES_SENT: 'certificates-sent',
  CERTIFICATE_PENDING: 'certificate-pending',
}

class CertificateWebSocketSubscriber extends BaseWebSocketSubscriber {
  init() {
    this.socketClient.on(MESSAGE_TYPES.CERTIFICATES_SENT, this.onCertificatesSent.bind(this))
    this.socketClient.on(MESSAGE_TYPES.CERTIFICATE_PENDING, this.onCertificatePending.bind(this))
  }

  onCertificatePending() {
    if (!this.$store.getters['liveCertificate/isLiveCertificateOn']) return
    this.$store.commit('liveCertificate/setCertificatePending', true)
  }

  onCertificatesSent(data) {
    if (!this.$store.getters['liveCertificate/isLiveCertificateOn']) return
    if (!data?.certificate?.verifyUrl) return
    this.$store.commit('liveCertificate/showCertificate', data.certificate)
  }
}

export default CertificateWebSocketSubscriber
